module.exports = __webpack_public_path__ + "static/media/PrivateHookah_1.cbc68131.jpg";